import { connect } from 'react-redux';
import { requestBookings, requestBooking, selectBooking } from '../modules/booking';

import Bookings from '../components/Bookings';

const mapDispatchToProps = {
  requestBookings,
  requestBooking,
  selectBooking,
};

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.booking.isFetching,
  needFetch: state.booking.needFetch,
  hasError: state.booking.hasError,
  requests: state.booking.requests,
  id: ownProps.params.id,
  selectedBooking: {
    request: state.booking.selectedBooking.request,
    hasError: state.booking.selectedBooking.hasError,
    isFetching: state.booking.selectedBooking.isFetching,
    needFetch: state.booking.selectedBooking.needFetch,
    activeTab: ownProps.params.key,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Bookings);



// WEBPACK FOOTER //
// src/routes/booking/containers/BookingsContainer.js